import {
  ChakraBox,
  ChakraButton,
  ChakraFlex,
  ChakraText,
  EquipUITheme,
  UniversalSelect,
} from '@equip.health/ui';
import { useHistory } from 'react-router-dom';

import { MESSAGES_TITLE } from '~/lib/constants/chat.constants';
import { getSelectedUniversalSelectOption } from '~/lib/util/inquiry.util';
import { Path } from '~/routes/constants';
import { PATIENT_MESSAGES_SIDEBAR_WIDTH } from '~/lib/constants/patients.constants';

const idPrefix = 'channel';
const idPostfix = 'tile';

const { label, paragraphBold, h5 } = EquipUITheme.typography;

interface EmptyChannelProps {
  id: string;
  patientId: string;
  selectedChannelType: string;
  channelTypeOptions: UniversalSelectOption[];
  onChannelTypeSelect: (newChannelType: string) => void;
}

const EmptyChannel = ({
  id,
  patientId,
  onChannelTypeSelect,
  channelTypeOptions,
  selectedChannelType,
}: EmptyChannelProps) => {
  const history = useHistory();

  return (
    <ChakraFlex
      direction="column"
      gridGap="10px"
      id={`${idPrefix}-container__${id}__${idPostfix}`}
      width={PATIENT_MESSAGES_SIDEBAR_WIDTH}
    >
      <ChakraFlex
        alignItems="center"
        height="71px"
        justifyContent="space-between"
      >
        <ChakraText
          {...h5}
          id={`${idPrefix}-channel-title__${id}__${idPostfix}`}
        >
          {MESSAGES_TITLE}
        </ChakraText>
        <ChakraFlex align="center" id="choose-channel-type-container">
          <UniversalSelect
            id={`${idPrefix}-messages-title__${id}__${idPostfix}`}
            isClearable={false}
            isSingleSelect
            onChange={(selectedOption: UniversalSelectOption) =>
              onChannelTypeSelect(selectedOption.value)
            }
            options={channelTypeOptions}
            value={getSelectedUniversalSelectOption(
              selectedChannelType,
              channelTypeOptions,
            )}
            variant="slim"
          />
        </ChakraFlex>
      </ChakraFlex>

      <ChakraBox maxWidth="302px" padding="0 27px" textAlign="center">
        <ChakraText
          {...paragraphBold}
          id={`${idPrefix}-channel-title__${id}__${idPostfix}`}
        >
          There aren&apos;t any messages here yet.
        </ChakraText>
        <ChakraText
          {...label}
          color="neutral.secondary"
          id={`${idPrefix}-channel-title__${id}__${idPostfix}`}
          paddingBottom="16px"
        >
          A patient needs to be assigned a team to start chatting.
        </ChakraText>
        <ChakraButton
          color="neutral.secondary"
          onClick={() => {
            history.push(`${Path.MAUD_PATIENTS}/${patientId}/care-planning`);
          }}
        >
          Manage teams
        </ChakraButton>
      </ChakraBox>
    </ChakraFlex>
  );
};

export default EmptyChannel;
